<section class="vm-carousel">
  <div class="vm-carousel__content">
    <ul class="vm-carousel__inner-content">
      <ng-container *ngFor="let slide of slides; let i = index">
        <li class="vm-carousel__item" *ngIf="activeSlide === i" [@fadeInOut]="'in'">
          <div class="vm-carousel__slide-wrapper">
          <ng-container [ngTemplateOutlet]="slide?.tpl"> </ng-container>
        </div>
        </li>
      </ng-container>
    </ul>
  </div>

  <div class="vm-carousel__status" *ngIf="showPips">
    <ul class="vm-carousel__status-list">
      <li *ngFor="let item of slides; let i = index" class="vm-carousel__status-item">
        <button
          class="vm-carousel__status-pip"
          [class.vm-carousel__status-pip--active]="activeSlide === i"
          [attr.aria-label]="'slide' + (i + 1)"
          [attr.title]="'slide' + (i + 1)"
        ></button>
      </li>
    </ul>
  </div>
</section>
